import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventCategory, GaTrackingEventName, GATrackingEventType } from '../../constants';

export class GATrackingFilterPLPsEvent implements GATrackingEvent {

  constructor(private filterName: string,
              private content: string,
              private eventType: GATrackingEventType,
              private eventName: GaTrackingEventName) {
  }

  getEventType(): GATrackingEventType {
    return this.eventType;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: this.eventName,
      label: this.filterName,
      category: GaTrackingEventCategory.Category,
      gtmCustom: {
        content: this.content
      }
    };
  }
}
